/* eslint-disable react/prop-types */
import React, { useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";
import { v4 as uuidV4 } from "uuid";

import SoftBox from "components/SoftBox";
import SoftButton from "components/SoftButton";
import DatePicker from "react-flatpickr";
import { Vietnamese } from "flatpickr/dist/l10n/vn";

const tableStyle = {
  borderCollapse: "collapse",
  width: "100%",
  fontSize: 13,
};

const thTdStyle = {
  border: "1px solid black",
  textAlign: "left",
  padding: "8px",
  fontWeight: 400,
};

const selectStyle = {
  fontSize: "0.875rem",
  color: "#495057",
  border: "0.0625rem solid #d2d6da",
  background: "#fff",
  padding: "0.5rem 0.75rem",
  width: "100%",
  borderRadius: "0.5rem",
  outline: "none",
  minWidth: 100,
};

const Td = ({ children, style, row, ...rest }) => {
  return (
    <th {...rest} style={{ ...thTdStyle, ...style }}>
      {children}
    </th>
  );
};

const dataTable = {
  muc1: [
    {
      id: uuidV4(),
      value2: "",
      value3: "",
      value4: "",
      value5: "",
      value6: "",
      value7: "",
      value8: "",
      value9: "",
    },
  ],
  muc2: [
    {
      id: uuidV4(),
      value2: "",
      value3: "",
      value4: "",
      value5: "",
      value6: "",
      value7: "",
      value8: "",
      value9: "",
    },
  ],
};

export default function TaxPersonalTable02({ formData, setFieldValue }) {
  const [data, setData] = useState(dataTable);

  useEffect(() => {
    setFieldValue("valuesTable", data);
  }, [data]);

  const handleChange = (values) => {
    const { id, name, value, rowType } = values;
    setData((prev) =>
      prev.map((item) => {
        if (item.id === id) {
          return { ...item, [name]: value };
        }
        return item;
      })
    );
  };

  const handleAdd = (rowType) => {
    const newRow = {
      id: uuidV4(),
      value2: "",
      value3: "",
      value4: "",
      value5: "",
      value6: "",
      value7: "",
      value8: "",
      value9: "",
    };
    setData((prev) => ({ ...prev, [rowType]: [...prev[rowType], newRow] }));
  };

  const handleDelete = (rowType, id) => {
    setData((prev) => ({ ...prev, [rowType]: prev[rowType].filter((item) => item.id !== id) }));
  };

  return (
    <Box display="flex" flexDirection="column" mt={5}>
      <Box display="flex" justifyContent="flex-end">
        <Typography variant="subtitle1" fontSize={14} fontStyle="italic">
          Đơn vị tiền: Đồng Việt Nam
        </Typography>
      </Box>
      <Box>
        <table style={tableStyle}>
          <tbody>
            <tr>
              <Td rowSpan={2} style={{ textAlign: "center", width: 20, background: "#d7d7d7" }}>
                STT
              </Td>
              <Td rowSpan={1} colSpan={2} style={{ textAlign: "center", background: "#d7d7d7" }}>
                Khác thác dầu khí
              </Td>
              <Td rowSpan={1} colSpan={4} style={{ textAlign: "center", background: "#d7d7d7" }}>
                Xuất bán dầu khí
              </Td>
              <Td rowSpan={2} style={{ textAlign: "center", background: "#d7d7d7" }}>
                Ghi chú
              </Td>
            </tr>
            <tr>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#d7d7d7" }}>
                Ngày, tháng, năm
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#d7d7d7" }}>
                Sản lượng
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#d7d7d7" }}>
                Ngày, tháng, năm
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#d7d7d7" }}>
                Sản lượng
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#d7d7d7" }}>
                Giá tính thuế tài nguyên tạm tính VND
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#d7d7d7" }}>
                Doanh thu VND
              </Td>
            </tr>
            <tr>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#d7d7d7" }}>
                (1)
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#d7d7d7" }}>
                (2)
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#d7d7d7" }}>
                (3)
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#d7d7d7" }}>
                (4)
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#d7d7d7" }}>
                (5)
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#d7d7d7" }}>
                (6)
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#d7d7d7" }}>
                (7)=(6)x(5)
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#d7d7d7" }}>
                (8)
              </Td>
            </tr>
            <tr>
              <Td
                className="toggle-button"
                colSpan={8}
                style={{ textAlign: "left", background: "#ddeff3", fontWeight: 800 }}
              >
                Xuất bán trong nước
                <div className="button-action" style={{ left: "-45px" }}>
                  <button onClick={() => handleAdd("muc1")} type="button">
                    Thêm dòng
                  </button>
                </div>
              </Td>
            </tr>
            {data.muc1.map((item, index) => (
              <tr key={item.id}>
                <Td className="toggle-button" rowSpan={1} style={{ textAlign: "center" }}>
                  {index + 1}
                  <div className="button-action delete">
                    <button onClick={() => handleDelete("muc1", item.id)} type="button">
                      Xóa dòng
                    </button>
                  </div>
                </Td>

                <Td rowSpan={1} style={{ textAlign: "center" }}>
                  <DatePicker
                    style={selectStyle}
                    options={{
                      locale: Vietnamese,
                      time_24hr: true,
                      dateFormat: "d-m-Y",
                    }}
                    name="value2"
                    onChange={(e) =>
                      handleChange({ rowType: "muc1", id: item.id, name: "value2", value: e[0] })
                    }
                  />
                </Td>
                <Td rowSpan={1} style={{ textAlign: "right" }}>
                  <InputTable
                    rowType="muc1"
                    id={item.id}
                    name="value3"
                    value={item.value3}
                    onChange={handleChange}
                  />
                </Td>
                <Td rowSpan={1} style={{ textAlign: "center" }}>
                  <DatePicker
                    style={selectStyle}
                    options={{
                      locale: Vietnamese,
                      time_24hr: true,
                      dateFormat: "d-m-Y",
                    }}
                    name="value4"
                    onChange={(e) =>
                      handleChange({ rowType: "muc1", id: item.id, name: "value4", value: e[0] })
                    }
                  />
                </Td>
                <Td rowSpan={1} style={{ textAlign: "right" }}>
                  <InputTable
                    rowType="muc1"
                    id={item.id}
                    name="value5"
                    value={item.value5}
                    onChange={handleChange}
                  />
                </Td>
                <Td rowSpan={1} style={{ textAlign: "right" }}>
                  <InputTable
                    rowType="muc1"
                    id={item.id}
                    name="value6"
                    value={item.value6}
                    onChange={handleChange}
                  />
                </Td>
                <Td rowSpan={1} style={{ textAlign: "right" }}>
                  <InputTable
                    rowType="muc1"
                    type="text"
                    id={item.id}
                    name="value7"
                    value={item.value7}
                    onChange={handleChange}
                  />
                </Td>
                <Td rowSpan={1} style={{ textAlign: "center" }}>
                  <InputTable
                    rowType="muc1"
                    type="text"
                    id={item.id}
                    name="value8"
                    value={item.value8}
                    onChange={handleChange}
                  />
                </Td>
              </tr>
            ))}

            <tr>
              <Td
                className="toggle-button"
                colSpan={8}
                style={{ textAlign: "left", background: "#ddeff3", fontWeight: 800 }}
              >
                Bán xuất khẩu
                <div className="button-action" style={{ left: "-45px" }}>
                  <button onClick={() => handleAdd("muc2")} type="button">
                    Thêm dòng
                  </button>
                </div>
              </Td>
            </tr>

            {data.muc2.map((item, index) => (
              <tr key={item.id}>
                <Td className="toggle-button" rowSpan={1} style={{ textAlign: "center" }}>
                  {index + 1}
                  <div className="button-action delete">
                    <button onClick={() => handleDelete("muc2", item.id)} type="button">
                      Xóa dòng
                    </button>
                  </div>
                </Td>

                <Td rowSpan={1} style={{ textAlign: "center" }}>
                  <DatePicker
                    style={selectStyle}
                    options={{
                      locale: Vietnamese,
                      time_24hr: true,
                      dateFormat: "d-m-Y",
                    }}
                    name="value2"
                    onChange={(e) =>
                      handleChange({ rowType: "muc2", id: item.id, name: "value2", value: e[0] })
                    }
                  />
                </Td>
                <Td rowSpan={1} style={{ textAlign: "right" }}>
                  <InputTable
                    rowType="muc2"
                    id={item.id}
                    name="value3"
                    value={item.value3}
                    onChange={handleChange}
                  />
                </Td>
                <Td rowSpan={1} style={{ textAlign: "center" }}>
                  <DatePicker
                    style={selectStyle}
                    options={{
                      locale: Vietnamese,
                      time_24hr: true,
                      dateFormat: "d-m-Y",
                    }}
                    name="value4"
                    onChange={(e) =>
                      handleChange({ rowType: "muc2", id: item.id, name: "value4", value: e[0] })
                    }
                  />
                </Td>
                <Td rowSpan={1} style={{ textAlign: "right" }}>
                  <InputTable
                    rowType="muc2"
                    id={item.id}
                    name="value5"
                    value={item.value5}
                    onChange={handleChange}
                  />
                </Td>
                <Td rowSpan={1} style={{ textAlign: "right" }}>
                  <InputTable
                    rowType="muc2"
                    id={item.id}
                    name="value6"
                    value={item.value6}
                    onChange={handleChange}
                  />
                </Td>
                <Td rowSpan={1} style={{ textAlign: "right" }}>
                  <InputTable
                    rowType="muc2"
                    type="text"
                    id={item.id}
                    name="value7"
                    value={item.value7}
                    onChange={handleChange}
                  />
                </Td>
                <Td rowSpan={1} style={{ textAlign: "center" }}>
                  <InputTable
                    rowType="muc2"
                    type="text"
                    id={item.id}
                    name="value8"
                    value={item.value8}
                    onChange={handleChange}
                  />
                </Td>
              </tr>
            ))}

            <tr>
              <Td style={{ textAlign: "center", background: "#ddeff3" }} colSpan={2}>
                Tổng cộng
              </Td>
              <Td style={{ textAlign: "center", background: "#ddeff3" }}></Td>
              <Td style={{ textAlign: "center", background: "#ddeff3" }}></Td>
              <Td style={{ textAlign: "right", background: "#ddeff3" }}>0,00</Td>
              <Td style={{ textAlign: "center", background: "#ddeff3" }}></Td>
              <Td style={{ textAlign: "right", background: "#ddeff3" }}>0,00</Td>
              <Td style={{ textAlign: "center", background: "#ddeff3" }}></Td>
            </tr>
          </tbody>
        </table>
      </Box>
    </Box>
  );
}

function InputTable(props) {
  const { id, onChange, type, ...rest } = props;
  const regexNumber = /^(0|[1-9]\d*)?$/;

  function handleChange(event) {
    const { name, value } = event.target;
    if (!type) {
      const newValue = value === "0" ? "" : value;
      if (!regexNumber.test(newValue)) return;
      onChange({ value: newValue !== "" ? +newValue : "", name, id });
    } else {
      onChange({ value, name, id });
    }
  }
  return (
    <input
      type="text"
      style={{
        textAlign: !type ? "right" : "left",
        fontSize: 13,
        color: "#495057",
        border: "0.0625rem solid #d2d6da",
        background: "#fff",
        padding: "0.5rem 0.75rem",
        width: "100%",
        borderRadius: "0.5rem",
        outline: "none",
      }}
      onChange={handleChange}
      {...rest}
    />
  );
}
